// extracted by mini-css-extract-plugin
export default {"spinner":"SelectButtonSpinner_spinner__cnACz","research-btn-spin":"SelectButtonSpinner_research-btn-spin__34OCM"};